// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"jL-z","loadingMedia":"kL-z","reviewsImagesAndVideos":"lL-z","limitHeight":"mL-z"};